module.exports = __webpack_public_path__ + "dffaba12827b029c037b1a5d17ed45f8.png";